<template>
  <a-divider orientation="left">参数调试</a-divider>
  <a-card bordered>
    <a-descriptions :column="2">
      <a-descriptions-item label="参数配置">
        <a-button type="primary" @click="erase">擦除参数</a-button>
      </a-descriptions-item>
      <a-descriptions-item label="修改二维码">
        <a-space>
          <a-input :style="{width:'150px'}" v-model:value="editCode"/>
          <a-button @click="submitCode">提交</a-button>
        </a-space>
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>
<script setup>

import load from "@/common/load";
import singleDev from "@/stores/singleDev";
import {onMounted, ref} from "vue";

let single = singleDev();
let editCode = ref("");
// 擦除参数
let erase = () => {
  load.confirm(`是否擦除${single.currentCode.qrCode}的参数？`, () => {
    let msg = 'rm /mnt/usr/device.conf /mnt/usr/bf_config ; /root/app/init_file.sh ; killall -s 9 mips_mqtt mips_rgled ; echo \'参数已擦除！\'';
    single.obtainTheDeviceNetworkingType('', function (topic, msg) {
      console.log(topic)
      console.log(msg)
      let timeout = setTimeout(() => {
        load.error("擦除参数超时...");
      }, 5000)
      if (msg.trim().includes("参数")) {
        load.success("参数已擦除");
        clearTimeout(timeout);
      }
    }, true, msg)
  })
}

onMounted(() => {
  editCode.value = single.currentCode.qrCode.substr(0, 2);
})
// 提交修改二维码
let submitCode = () => {
  load.confirm(`是否将二维码${single.currentCode.qrCode}修改成${editCode.value}?`, () => {
    if (editCode.value.length === 8) {
      let msg = 'echo -n ' + editCode.value + ' > /mnt/usr/bf_code && echo \'code <\'$(cat /mnt/usr/bf_code)\'> write OK!\' && /root/app/tools/set_mac.sh ' + editCode.value;
      single.obtainTheDeviceNetworkingType('', function (topic, msg) {
        console.log(topic)
        console.log(msg)
        let timeout = setTimeout(() => {
          load.error("修改二维码超时...");
        }, 5000)
        if (msg.trim().includes("OK")) {
          load.success("更改二维码成功!重启设备后,二维码生效");
          clearTimeout(timeout);
        }
      }, true, msg)
    } else {
      load.error("二维码长度不符合规范...");
    }
  })

}
</script>
<style scoped lang="scss">

</style>
